module.exports = {
	googleKey2domains: [
		"app.reputate.co.za",
		"reviews.marketingbyrob.com",
		"places.gvp.digital",
		"app.bizzrep.com",
		"app.localclarity.com.br",
		"locations.localorm.com",
		"app.ormanagement.co",
		"reviews.flextsms.com",
		"grow.digimarketer.ca",
		"local.leadcrossing.com",
		"app.googlebusiness.ca",
		"app.hospitality-buddy.eu",
		"orm.marinemarketingsolutions.net",
		"app.onereputation.it",
		"reviews.rankmeone.ai",
		"respond.overallreviews.com",
	],
	googleKey3domains: [
		"cloud.mybusiness.tw",
		"app.beoordeel.online",
		"canada.localclarity.com",
		"app.localtouch.io",
		"stage.localclarity.com",
		"reputation.easyfishmarketing.com",
		"local.findyouraudience.online",
		"gmn.astradigital.com.br",
		"reputation.itsevolve.com",
	],
	googleKey4domains: [
		"reputation.apt.co.ke",
		"reviews.engageq.com",
		"app.getlocaladvantage.com",
		"client.googavis.fr",
	],
	googleKey5domains: [
		"reviews.overthetopseo.com",
		"reply.asterfive.com",
		"reviews.motivatedmarketing.com",
		"reputation.thatsbiz.com",
		"footfall.opositive.io",
        "reviews.restauranter.pt",
        "control.wela.com",
        "reviews.skyeline.com",
	],
};
